<template>
  <b-container fluid class="h-100">

    <b-row no-gutters class="header mt-3 pb-1 w-100" id="top-area">
      <b-col>
        <h2>{{$t('campaigns.campaigns')}}</h2>
        <p class="d-none d-md-block">{{$t('tutorial.campaignsExample')}}</p>
      </b-col>
      <b-col cols="5" class="d-md-none m-0 p-0 text-right">
        <!-- take your pick.. -->
        <!-- <b-button class="m-1 border-success text-success" variant="light" v-b-modal.new>
          <span><b-icon icon="film"></b-icon> {{$t('dashboard.links.newCampaign')}}</span>
        </b-button> -->
        <b-button variant="outline-danger" v-b-modal.new>Create <b-icon class="d-inline" icon="plus-circle-fill"></b-icon></b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="d-md-none">
        <multiselect class="" :options="filtered" track-by="campaignId" label="name" @select="selectCampaign"
          :value="compSelected" :searchable="false" :allow-empty="false">
            <template #singleLabel>
              <div class="trim">{{ compSelected.name }}</div>
            </template>
          </multiselect>
      </b-col>
    </b-row>

    <b-row v-if="loading" id="content-area">
      <div class="spinner">
      </div>
    </b-row>

    <b-row v-else id="content-area">
      <b-col md="4" lg="2" ref="sidebar" class="d-none d-md-block h-100 overflow list">
        <b-form-input id="search" class="search" :placeholder="$t('actions.search')" v-model="search"></b-form-input>
        <div class="new-item item" v-b-modal.new>
          <v-icon name="plus" scale="1.5" label="New Campaign"></v-icon>
        </div>

        <template v-if="filtered.length > 0">
          <div :key="campaign.campaignId" v-for="campaign in filtered" @click="selectCampaign(campaign)"
            :id="'c_'+campaign.campaignId"
            class="pt-3 pb-3 item overflow"
            :class="{ selected: compSelected.campaignId === campaign.campaignId }">
            {{ campaign.name }}
            <div class="text-muted"><small>
                <b>{{ campaign.media.data.reduce((a,c) => Math.max(a,c.end), 0) }}</b> seconds,
                <b>{{ Number(campaign.media.data.reduce((a,c) => Math.max(a,c.size), 0) / 1024 / 1024).toFixed(2) }}</b>
                MB
              </small></div>
          </div>
          <div v-if="campaignPage < campaignTotalPages" class="item text-center text-muted py-2" @click="loadMoreCampaigns" style="cursor:pointer;">
            <small>{{ loadingMore ? 'Loading...' : 'Load more...' }}</small>
          </div>
        </template>
        <template v-else-if="this.activeTeam.id == 0">
          <div class="pt-4 text-muted text-center">{{$t('campaigns.noTeam')}}</div>
        </template>
        <template v-else>
          <div class="pt-4 text-muted text-center">{{$t('campaigns.noCampaigns')}}</div>
        </template>

      </b-col>

      <b-col cols="12" md="8" lg="10" class="h-100 overflow">
        <transition name="fade">
          <router-view v-if="filtered.length > 0 && compSelected.campaignId && $route.params.campaignId"
            :activeTeam="activeTeam" :campaign="compSelected" @close="closeEdit()" @delete="fetchCampaigns(null)"
            @update="fetchCampaigns(null)" @refresh="refreshCampaigns" @refreshCampaign="refreshSelected">
          </router-view>
        </transition>
      </b-col>

    </b-row>

    <b-modal id="new" size="md" :title="$t('campaigns.newCampaign')" hide-footer>
      <div class="alert alert-danger" v-if="errors.length > 0">
        <ul>
          <li v-bind:key="index" v-for="(error, index) in errors">
            {{ error }}
          </li>
        </ul>
      </div>
      <b-row v-on:keyup.enter.prevent.stop="createCampaign()">
        <b-col cols="12" id="campaignInformation">
          <b-form-group :label="$t('campaigns.campaignName')" label-for="name">
            <b-form-input id="name" class="form-control" :placeholder="$t('campaigns.campaignName')" v-model="newName">
            </b-form-input>
          </b-form-group>
          <b-form-group :label="$t('common.team')">
            <b-input disabled :value="activeTeam.name"></b-input>
          </b-form-group>
          <b-form-group>
            <b-button class="mt-2" variant="primary" @click="createCampaign">{{$t('buttons.create')}}</b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <!-- TODO: add computed name with pencil fa-icon -->
    <b-modal v-if="compSelected.campaignId || loading" id="edit-new" size="xl" :title="compSelected.name" hide-footer>
      <campaign-editor :activeTeam="activeTeam" :campaign="compSelected" @saved="closeEdit()"></campaign-editor>
    </b-modal>
  </b-container>
</template>

<style scoped lang="scss">
.header {
  display: inline-flex;
  background-color: white;
  z-index: 100;
  /*border-bottom: 1px #e9e9e9 solid; */
}

.multiselect--active {
  z-index: 999999;
}

.trim {
  width: 100%;
  font-size: small;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/*.multiselect__single {
  font-size: x-large;
}*/

.item:hover,
.selected {
  background-color: #e6e6e6;
}

.item {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.25;
  padding-top: .425rem;
  padding-bottom: .425rem;
  padding-left: 20px;
  display: block;
  border-bottom: #e9e9e9 solid 1px;
}

.overflow {
  overflow-y: auto;
  display: block;
}

.search {
  width: 100%;
  height: 54px;
  border: none;
  text-align: center;
  border-bottom: 1px #e9e9e9 solid;
}

.new-item {
  padding-left: 0;
  text-align: center;
}

.list {
  border-right: #e9e9e9 solid 1px;
  padding: 0px;
}

.spinner {
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
}
</style>

<script>
import CampaignEditor from '@/components/CampaignEditor/CampaignEditor.vue'
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/plus'
import teamContext from '@/mixins/teamContext'
import autoResize from '@/mixins/autoResize'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'


export default {
  name: 'Campaigns',
  mixins: [teamContext, autoResize],
  components: {
    CampaignEditor,
    Multiselect,
  },
  data () {
    return {
      campaigns: [],
      search: '',
      newName: '',
      loaded: false,
      errors: [],
      loading: true,
      campaignPage: 1,
      campaignPageSize: 100,
      campaignTotalPages: 1,
      loadingMore: false,
      searchResults: null,
      searching: false,
    }
  },
  computed: {
    filtered () {
      const source = this.searchResults !== null ? this.searchResults : this.campaigns
      return source.filter((campaign) => {
        if (this.search === '') {
          return true
        } else {
          for (var t = 0; t < campaign.tags.data.length; t++) {
            if (campaign.tags.data[t].tag.toLowerCase().includes(this.search.toLowerCase())) {
              return true
            }
          }
          return campaign.name.toLowerCase().includes(this.search.toLowerCase())
        }
      })
    },
    compSelected() {
      // resolve from the same source as `filtered`: during a search the selected
      // campaign may only exist in searchResults (a full limit=all search), not in
      // the paginated `campaigns` first page. Looking only in `campaigns` returned
      // {} for those, so the player got an empty campaign -> "No Media".
      const source = this.searchResults !== null ? this.searchResults : this.campaigns
      let selected = source.find((campaign) => {
        return campaign.campaignId === parseInt(this.$route.params.campaignId)
      })
      if (selected)
        return selected
      else
        return {}
    }
  },
  watch: {
    filtered() {
      this.updateRoute()
    },
    search: _.debounce(function (val) {
      if (val === '') {
        this.searchResults = null
      } else {
        this.searching = true
        this.$axios.get(`v1/campaigns?include=tags,media&limit=all&team=${parseInt(this.activeTeam.id)}&search=${encodeURIComponent(val)}`)
          .then(r => { this.searchResults = r.data.data; this.searching = false })
          .catch(() => { this.searchResults = null; this.searching = false })
      }
    }, 300),
    'activeTeam': function() {
      this.loading = true
      this.search = ''
      this.searchResults = null
      this.fetchCampaigns(null)
    },
  },
  mounted () {
    this.fetchCampaigns(null)
  },
  beforeDestroy () {
  },
  methods: {
    updateRoute() {
      if (this.filtered.length > 0) {
        let maybeId = this.$route.params?.campaignId
        if (maybeId !== undefined) {
          let maybeCampaign = this.filtered.find(d => d.campaignId == maybeId)
          if (maybeCampaign !== undefined) {
           //to make scrollbar jump to the selected item
            this.$nextTick(() => {
              const cid = document.querySelector('#c_'+maybeId)
              if (cid){
                this.$refs.sidebar.scrollTop = cid.offsetTop
              }
            })

            // We're already on this campaign's route; navigating to it again
            // rejects with NavigationDuplicated. Just keep the current route.
            return
          }
          else {
            this.$router.replace({ name: 'campaigns' }).catch(() => {})
          }
        }
        return this.$router.replace({ name: 'campaign', params: { campaignId: this.filtered[0].campaignId } }).catch(() => {})
      }
    },
    fetchCampaigns(newId) {
      console.log('[fetchCampaigns]')
      var scope = this
      // On refresh the active team starts as id 0 ("none selected") and is only
      // restored asynchronously. Fetching with team=0 returns 404 and races the
      // real fetch, wiping the campaign list (blank/black player). Skip it; the
      // activeTeam watcher re-fetches once a real team is set.
      if (!this.activeTeam || parseInt(this.activeTeam.id) === 0) {
        this.campaigns = []
        this.loading = false
        return
      }
      this.loading = true
      this.campaignPage = 1
      let url = `v1/campaigns?limit=${this.campaignPageSize}&page=1&include=tags,media&team=` + parseInt(this.activeTeam.id)
      this.$axios.get(url).then(
        (response) => {
          this.campaigns = response.data.data
          this.meta = response.data.meta
          this.campaignTotalPages = response.data.meta ? response.data.meta.totalPages : 1
          this.changing = false
          this.loading = false
          if (newId !== null) {
            this.$router.push({
              name: 'campaign',
              params: {
                campaignId: newId
              }
            })
            // TODO should be this.selectedObject?
            this.$bvModal.hide('new')
            this.$bvModal.show('edit-new')
          }
        }).catch(
        function (error) {
          if (!error.response) {
            scope.$notifications.add({
              title: 'Error',
              type: 'warning',
              body: error.message,
              timeout: true
            })
          } else if (error.response.status !== 404) {
            scope.$notifications.add({
              title: 'Error',
              type: 'warning',
              body: error.response.data.message,
              timeout: true
            })
          }
          scope.campaigns = []
          scope.fetchMedia()
          scope.loading = false
        }
      )
    },
    refreshSelected () {
      console.log('[refreshSelected]')  
      var scope = this
      this.$axios.get('v1/campaigns/' + this.selectedObject.campaignId + '&include=tags,media').then(
        (response) => {
          let index = this.campaigns.findIndex((element) => {
            return element.campaignId === this.selectedObject
          })
          this.campaigns[index] = response.data.data
          this.selectedObject = response.data.data
        }).catch(
        function (error) {
          if (!error.response) {
            scope.$notifications.add({
              title: 'Error',
              type: 'warning',
              body: error.message,
              timeout: true
            })
          } else if (error.response.status !== 404) {
            scope.$notifications.add({
              title: 'Error',
              type: 'warning',
              body: error.response.data.message,
              timeout: true
            })
          }
        }
      )
    },
    fetchMedia () {
      this.$axios.get('v1/media?limit=1&team=' + parseInt(this.activeTeam.id)).then(
        () => {},
        (response) => {
          if (response.status === 404) {
            this.$notifications.add({
              title: 'Notification',
              type: 'info',
              body: this.$t('notifications.mediaNone'),
              timeout: true,
              dismissable: true
            })
          }
        }
      )
    },
    loadMoreCampaigns () {
      console.log('[loadMore]') 
      if (this.loadingMore || this.campaignPage >= this.campaignTotalPages) return
      this.loadingMore = true
      this.campaignPage++
      const url = `v1/campaigns?limit=${this.campaignPageSize}&page=${this.campaignPage}&include=tags,media&team=` + parseInt(this.activeTeam.id)
      this.$axios.get(url).then(response => {
        this.campaigns = this.campaigns.concat(response.data.data)
        this.loadingMore = false
      }).catch(() => { this.loadingMore = false })
    },
    selectCampaign (campaign) {
      // clicking the already-selected campaign would push to the current route
      // and reject with NavigationDuplicated
      if (parseInt(this.$route.params.campaignId) === campaign.campaignId) {
        return
      }
      this.$router.push({ name: 'campaign', params: { campaignId: campaign.campaignId } }).catch(() => {})
    },
    refreshCampaigns () {
      if (this.$router.currentRoute.name === 'campaigns') {
        this.fetchCampaigns(null)
      }
    },
    createCampaign () {
      var scope = this
      this.errors = []
      if (this.newName !== '') {
        let deets = { name: this.newName, teamName: this.activeTeam.name }
        this.$axios.post('v1/campaigns', deets).then(
        (response) => {
          this.fetchCampaigns(response.data.data.campaignId)
        }).catch(
        function (error) {
          if (!error.response) {
            scope.$notifications.add({
              title: 'Error',
              type: 'warning',
              body: error.message,
              timeout: true
            })
          } else if (error.response.status !== 404) {
            scope.$notifications.add({
              title: 'Error',
              type: 'warning',
              body: error.response.data.message,
              timeout: true
            })
          }
        }
      )
      }
      else {
        this.errors.push(this.$t('campaigns.emptyName'))
      }
    },
    closeEdit () {
      // this is a bit of a kludge
      this.$bvModal.hide('edit-new')
      this.$bvModal.hide('edit-modal')
      this.campaign = {}
      this.newCampaign = {}
      this.fetchCampaigns(null)
    },
  }
}
</script>
